// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3D2cD","approved":"Status_approved__2b3a4","rejected":"Status_rejected__1W5Px","expired":"Status_expired__3MuB9","label":"Status_label__J_nXf"};